import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { LockGlyph12Icon } from 'assets/icons'
import InitiativeDefaultThumbnail from 'src/sites/kits/Initiative/components/DefaultThumbnail'

const InitiativeListItemDetailsCard = ({
   coverMedia,
   iconName,
   linkTo,
   meta,
   name,
   nameTextSize,
   privacy,
   subtitle,
   summary,
   textColor,
   thumbnailHeight,
   thumbnailSpacing,
   thumbnailWidth
}) => (
   <Link to={linkTo}>
      <View display="flex" width="100%">
         <View
            flex="0 0 auto"
            width={thumbnailWidth}
            height={thumbnailHeight}
            backgroundColor="#eee"
            backgroundImage={coverMedia && `url(${coverMedia?.file.thumbnailUrlW480})`}
            backgroundSize="cover"
            backgroundPosition="center center"
            backgroundRepeat="no-repeat"
            borderRadius="6px"
            border="1px solid #ddd"
            style={{ overflow: 'hidden' }}>
            {!coverMedia && (
               <InitiativeDefaultThumbnail
                  highlightColor="#eee"
                  iconColor="#ccc"
                  iconName={iconName}
                  iconSize="24px"
               />
            )}
         </View>
         <View
            flex="0 0 auto"
            paddingLeft={thumbnailSpacing}
            width="calc(100% - 60px)">
            <Text
               size={nameTextSize}
               lineHeight="120%"
               weight="medium"
               color={textColor}
               style={{ wordWrap: 'break-word' }}>
               {name}
            </Text>
            {(subtitle || summary) && (
               <View
                  margin="5px 0px"
                  maxHeight="55px[a-d] 55px[e-f]"
                  style={{
                     overflow: 'hidden',
                     textOverflow: 'ellipsis',
                     wordBreak: 'break-word'
                  }}>
                  <Text
                     size="2[a-c] 1.5[d] 2[e-f]"
                     lineHeight="130%"
                     color="#888">
                     {subtitle}
                     {!subtitle && <div dangerouslySetInnerHTML={{ __html: summary }} />}
                  </Text>
               </View>
            )}
            {meta?.length > 0 && (
               <View marginTop="5px[e-f]">
                  <Text size="1.5" color="#aaa" letterSpacing="-0.3px">
                     {meta.map((item, index) => (
                        <React.Fragment key={item}>
                           {index !== 0 ? <>&nbsp;&nbsp;&#183;&nbsp;&nbsp;</> : ''}
                           {item}
                        </React.Fragment>
                     ))}
                  </Text>
               </View>
            )}
            {['admin', 'draft', 'private'].includes(privacy) && (
               <View
                  display="inline-flex"
                  alignItems="center"
                  backgroundColor={privacy === 'draft'
                     ? 'rgba(247, 183, 124, 1)'
                     : 'rgba(0,0,0,0.3)'
                  }
                  borderRadius="2px"
                  padding="5px 5px"
                  marginTop="5px">
                  {privacy !== 'draft' && (
                     <View display="flex" alignItems="center" marginRight="5px">
                        <LockGlyph12Icon
                           color="rgba(255,255,255,0.5)"
                           width="7px"
                           height="7px"
                        />
                     </View>
                  )}
                  <Text
                     size="0.7"
                     lineHeight="100%"
                     color={privacy === 'draft' ? '#000' : 'rgba(255,255,255,0.8)'}
                     weight="medium"
                     transform="uppercase">
                     {privacy}
                  </Text>
               </View>
            )}
         </View>
      </View>
   </Link>
)

InitiativeListItemDetailsCard.propTypes = {
   coverMedia: PropTypes.object,
   iconName: PropTypes.string,
   linkTo: PropTypes.string.isRequired,
   meta: PropTypes.arrayOf(PropTypes.string),
   name: PropTypes.string.isRequired,
   nameTextSize: PropTypes.string,
   privacy: PropTypes.string,
   subtitle: PropTypes.string,
   summary: PropTypes.string,
   textColor: PropTypes.string.isRequired,
   thumbnailHeight: PropTypes.string,
   thumbnailSpacing: PropTypes.string,
   thumbnailWidth: PropTypes.string
}

InitiativeListItemDetailsCard.defaultProps = {
   coverMedia: undefined,
   iconName: undefined,
   meta: undefined,
   nameTextSize: '2[a-c] 1.5[d] 2.5[e-f]',
   privacy: undefined,
   subtitle: undefined,
   summary: undefined,
   thumbnailHeight: '40px[a-d] 50px[e-f]',
   thumbnailSpacing: '20px',
   thumbnailWidth: '40px[a-d] 50px[e-f]'
}

export default InitiativeListItemDetailsCard
